import global from './global.json';
import account from './account.json';
import checkout from './checkout.json';
import cms from './cms.json';
import composable from './composable.json';
import cookie from './cookie.json';
import error from './error.json';
import layout from './layout.json';
import listing from './listing.json';
import navigation from './navigation.json';
import order from './order.json';
import product from './product.json';
import search from './search.json';
import shared from './shared.json';
import utility from './utility.json';
import violations from './violations.json';
import wishlist from './wishlist.json';

export default {
    ...global,
    ...account,
    ...checkout,
    ...cms,
    ...composable,
    ...cookie,
    ...error,
    ...layout,
    ...listing,
    ...navigation,
    ...order,
    ...product,
    ...search,
    ...shared,
    ...utility,
    ...violations,
    ...wishlist,
};
